import { withSearch } from "@elastic/react-search-ui";
import { TabWrapper } from "components/search/buckets/SearchWithFilter/common/TabView/style";
import SnomedResults from "components/search/results/SnomedResults";
import { useStoreContext } from "context/StoreProvider";
import { useEffect } from "react";
import { Col, Nav, Tab } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import SnomedBodyResults from "../BodyResults";

type TabViewProps = {
  totalResults: number;
  resultSearchTerm: string;
  searchTerm: string;
};

const SnomedTabView = ({
  totalResults,
  resultSearchTerm,
  searchTerm
}: TabViewProps) => {
  const { state } = useStoreContext();
  const { code } = state;
  const { view } = useParams();
  const navigate = useNavigate();

  const searchString = "search";
  const resultString = "result";

  const getResultTabLabel = (): string => {
    if (!code) {
      return "Resultat ";
    }
    return `Resultat (${code})`;
  };

  const handleSetActiveTab = (newActiveKey: string) => {
    if (view === newActiveKey) {
      return null;
    }
    navigate(newActiveKey);
  };

  useEffect(() => {
    if (view === undefined) {
      navigate(searchString);
    }
    if (searchTerm !== resultSearchTerm && view === resultString) {
      navigate(searchString);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, searchTerm]);

  const headerHeight =
    document.querySelector("#site-header")?.clientHeight || 0;
  const searchWrapperHeight =
    document.querySelector("#snomed-search-wrapper")?.clientHeight || 0;

  const calculateHeight = headerHeight + searchWrapperHeight;

  return (
    <>
      <Tab.Container
        id="tab-search"
        activeKey={view}
        onSelect={(k: string | null) => navigate(k as string)}
      >
        <TabWrapper $topValue={calculateHeight} className="flex-column p-0">
          <Col
            id={`tab-view-snomed`}
            className="tab-bar d-flex flex-column-reverse flex-lg-row justify-content-between p-0"
          >
            <Nav className="flex-row">
              <Nav.Item tabIndex={0}>
                <Nav.Link
                  onClick={() => handleSetActiveTab(searchString)}
                  eventKey={searchString}
                >
                  {`Søkeresultat${
                    totalResults > 0 &&
                    resultSearchTerm &&
                    ` (${totalResults} treff)`
                  }`}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item tabIndex={0} aria-disabled={!code}>
                <Nav.Link
                  eventKey={resultString}
                  onClick={() => handleSetActiveTab(resultString)}
                  disabled={true}
                >
                  {getResultTabLabel()}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col>
            <Tab.Content>
              <Tab.Pane eventKey={searchString}>
                <SnomedBodyResults />
              </Tab.Pane>
              <Tab.Pane eventKey={resultString}>
                <SnomedResults />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </TabWrapper>
      </Tab.Container>
    </>
  );
};

export default withSearch(({ totalResults, resultSearchTerm, searchTerm }) => ({
  totalResults,
  resultSearchTerm,
  searchTerm
}))(SnomedTabView);
